import { createSlice } from "@reduxjs/toolkit";
import {
  fetchMyaccountLogin,
  updateLoginInformation,
  fetchUpdateToken,
  updatePassword,
} from "./myaccountActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const myaccountLoginSlice = createSlice({
  name: "myaccountLogin",
  initialState: {
    isLoading: false,
    error: null,
    errorMsg: "",
    myaccountLogin: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyaccountLogin.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.errorMsg = "";
      })
      .addCase(fetchMyaccountLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.success) {
          state.error = true;
          state.errorMsg = getApiErrorMessage(action.payload.status);
        } else {
          if (action.payload?.data?.data?.AuthorizationDTO) {
            state.myaccountLogin = action.payload.data.data.AuthorizationDTO;
          } else if (action.payload?.data) {
            state.myaccountLogin = action.payload.data;
          }
        }
      })
      .addCase(fetchMyaccountLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.error = true;
        state.errorMsg = action.error.message;
      });
  },
});

const updateLoginInfoSlice = createSlice({
  name: "updateLoginInfo",
  initialState: {
    isLoading: false,
    error: null,
    errorMsg: "",
    updateSuccess: false,
    userData: {},
  },
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateLoginInformation.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.errorMsg = "";
        state.updateSuccess = false;
      })
      .addCase(updateLoginInformation.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.success) {
          state.error = true;
          state.errorMsg = getApiErrorMessage(action.payload.status);
          state.updateSuccess = false;
        } else {
          state.updateSuccess = true;
          state.userData = action.payload.data;
        }
      })
      .addCase(updateLoginInformation.rejected, (state, action) => {
        state.isLoading = false;
        state.error = true;
        state.errorMsg = action.error.message;
        state.updateSuccess = false;
      });
  },
});

const updateTokenSlice = createSlice({
  name: "updateToken",
  initialState: {
    isLoading: false,
    error: null,
    errorMsg: "",
    updateSuccess: false,
    tokenData: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUpdateToken.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.errorMsg = "";
      })
      .addCase(fetchUpdateToken.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.success) {
          state.error = true;
          state.errorMsg = getApiErrorMessage(action.payload.status);
          state.updateSuccess = false;
        } else {
          state.updateSuccess = true;
          state.tokenData = action.payload.data;
        }
      })
      .addCase(fetchUpdateToken.rejected, (state, action) => {
        state.isLoading = false;
        state.error = true;
        state.errorMsg = action.error.message;
        state.updateSuccess = false;
      });
  },
});

const updatePasswordSlice = createSlice({
  name: "updatePassword",
  initialState: {
    isLoading: false,
    error: null,
    errorMsg: "",
    updateSuccess: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updatePassword.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.errorMsg = "";
        state.updateSuccess = false;
      })
      .addCase(updatePassword.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.success) {
          state.error = true;
          state.errorMsg = getApiErrorMessage(action.payload.status);
          state.updateSuccess = false;
        } else {
          state.updateSuccess = true;
        }
      })
      .addCase(updatePassword.rejected, (state, action) => {
        state.isLoading = false;
        state.error = true;
        state.errorMsg = action.error.message;
        state.updateSuccess = false;
      });
  },
});

export const { resetUpdateStatus } = updateLoginInfoSlice.actions;
export const myaccountLoginReducer = myaccountLoginSlice.reducer;
export const updateLoginInfoReducer = updateLoginInfoSlice.reducer;
export const updateTokenReducer = updateTokenSlice.reducer;
export const updatePasswordReducer = updatePasswordSlice.reducer;
